module.exports = {
      id: "arrow-left-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }